import {
  DataEntryAccidentStepSectionProps,
  FormikInjured,
  typedMemo,
  YesNoAnswer,
} from "src/types";
import { Button, FormRow, InputGroup } from "src/ui/widgets";
import { InjuredForm } from "./injured";
import { useDataEntryAccidentStepInjured } from "./accident-step-injured.hook";
import { FormikErrors, FormikTouched } from "formik";
import { ChangeEvent } from "react";

export const DataEntryAccidentStepInjured = typedMemo(
  (props: DataEntryAccidentStepSectionProps) => {
    const {
      formikAccidentValues,
      formikAccidentErrors,
      formikAccidentTouched,
      formik,
      validationSchema,
    } = props;

    const { handleChange, handleBlur } = formik;

    const {
      yesNoOptions,
      removeInjuredButtonVisible,
      injuredsListVisible,
      t,
      onAddInjuredClick,
      onRemoveInjuredClick,
      onSelectInjuredQuestion,
    } = useDataEntryAccidentStepInjured(props);

    return (
      <>
        <FormRow
          firstField={
            <InputGroup
              style="radio"
              name="accidentData.injuredsInfo.injuredQuestion"
              handleChange={(event: ChangeEvent<HTMLInputElement>) => {
                onSelectInjuredQuestion(event);
                handleChange(event);
              }}
              handleBlur={handleBlur}
              options={yesNoOptions}
              validationSchema={validationSchema}
              touched={formikAccidentTouched?.injuredsInfo?.injuredQuestion}
              value={formikAccidentValues.injuredsInfo?.injuredQuestion}
              error={formikAccidentErrors?.injuredsInfo?.injuredQuestion}
              label={t(
                "data_entry.accident_step.section_injured_injured_question"
              )}
              classes="m-0 ps-0"
              classesLabel="m-0 p-0 d-flex align-items-center mb-3"
            />
          }
        />
        {injuredsListVisible && (
          <>
            <div className="mt-4">
              {formikAccidentValues.injuredsInfo?.injuredList.map(
                (injured, index) => (
                  <InjuredForm
                    key={injured.fiscalCode}
                    injured_number={index}
                    formikInjuredValues={
                      formikAccidentValues.injuredsInfo?.injuredList?.[index]
                    }
                    formikInjuredErrors={
                      formikAccidentErrors?.injuredsInfo?.injuredList?.[
                        index
                      ] as FormikErrors<FormikInjured>
                    }
                    formikInjuredTouched={
                      formikAccidentTouched?.injuredsInfo?.injuredList?.[
                        index
                      ] as FormikTouched<FormikInjured>
                    }
                    formik={formik}
                    validationSchema={validationSchema}
                  />
                )
              )}
            </div>

            <div className="d-flex gap-4 justify-content-center mt-2">
              {removeInjuredButtonVisible && (
                <Button
                  flavor="primaryFlipRemove"
                  classes="px-auto py-2"
                  text={`${t("commons.delete")} ${t("commons.injured")} `}
                  classesText="text-uppercase label-l--500"
                  onPress={onRemoveInjuredClick}
                />
              )}
              <Button
                flavor="primaryAdd"
                classes="px-auto py-2"
                text={`${t("commons.add")} ${t("commons.injured")} `}
                classesText="text-uppercase label-l--500"
                onPress={onAddInjuredClick}
              />
            </div>
          </>
        )}
      </>
    );
  }
);
